import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider.jsx";
import { fetchOrganizations } from "../api.js";
import { Button } from "../components/ui/button.jsx";

export default function SuperadminDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrganizations()
      .then(setOrgs)
      .catch((err) => setError(err.response?.data?.detail || "Erro ao carregar organizacoes"))
      .finally(() => setLoading(false));
  }, []);

  const handleLogout = async () => {
    await logout();
  };

  if (loading) {
    return (
      <main className="min-h-screen bg-background p-6 md:p-12">
        <p className="text-white text-center">A carregar...</p>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-background p-6 md:p-12">
      <div className="max-w-6xl mx-auto">
        <header className="mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-gold mb-2">
                Organizacoes
              </h1>
              <p className="text-muted text-lg">
                Bem-vindo, {user?.user_metadata?.name || user?.email || "equipa"}.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Button onClick={() => navigate("/admin/orgs/new")}>
                Criar organizacao
              </Button>
              <Button variant="outline" size="default" onClick={handleLogout}>
                Terminar sessao
              </Button>
            </div>
          </div>
        </header>

        {error && (
          <div className="bg-red-500/10 border border-red-500/20 text-red-400 p-4 rounded-lg mb-6">
            {error}
          </div>
        )}

        {orgs.length === 0 ? (
          <p className="text-muted text-center">Nenhuma organizacao registada.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {orgs.map((org) => (
              <div
                key={org.id}
                onClick={() => navigate(`/admin/${org.slug}`)}
                className={`bg-card border border-border rounded-lg p-6 cursor-pointer hover:border-gold/50 transition-all ${
                  org.active === false ? "opacity-50" : ""
                }`}
              >
                <h3 className="text-xl font-semibold text-white mb-2">
                  {org.name}
                </h3>
                <p className="text-sm text-muted mb-3">{org.slug}</p>
                <span
                  className={`inline-block px-3 py-1 text-xs font-medium rounded-full ${
                    org.active === false
                      ? "bg-red-500/10 text-red-400"
                      : "bg-green-500/10 text-green-400"
                  }`}
                >
                  {org.active === false ? "Inativa" : "Ativa"}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
